module.exports = __webpack_public_path__ + "static/cause-effect-531c29a77d03d880914995feb9f29b8d.jpg";